
import { Operators_IsNull } from "../fable-library-js.5.13.0/FSharp.Core.js";
import { Record } from "../fable-library-js.5.13.0/Types.js";
import { unit_type, record_type, lambda_type, bool_type } from "../fable-library-js.5.13.0/Reflection.js";
import * as react from "react";
import { equalArrays, equals } from "../fable-library-js.5.13.0/Util.js";

export function Internal_updateInputValue(value, e) {
    if (!Operators_IsNull(e) && (e.value !== value)) {
        e.value = value;
    }
}

export class MemoProps1$1 extends Record {
    constructor(model, equal) {
        super();
        this.model = model;
        this.equal = equal;
    }
}

export function MemoProps1$1_$reflection(gen0) {
    return record_type("Elmish.React.MemoProps1`1", [gen0], MemoProps1$1, () => [["model", gen0], ["equal", lambda_type(gen0, lambda_type(gen0, bool_type))]]);
}

export class MemoProps2$2 extends Record {
    constructor(model, dispatch, equal) {
        super();
        this.model = model;
        this.dispatch = dispatch;
        this.equal = equal;
    }
}

export function MemoProps2$2_$reflection(gen0, gen1) {
    return record_type("Elmish.React.MemoProps2`2", [gen0, gen1], MemoProps2$2, () => [["model", gen0], ["dispatch", lambda_type(gen1, unit_type)], ["equal", lambda_type(gen0, lambda_type(gen0, bool_type))]]);
}

/**
 * Avoid rendering the view unless the model has changed.
 * equal: function to compare the previous and the new states
 * view: function to render the model
 * state: new state to render
 */
export function Common_lazyViewWith(equal, view, state) {
    const memoized = view.__memo || (view.__memo = (() => {
        const m = react.memo((props) => view(props.model), (prev, next) => next.equal(prev.model, next.model));
        m.displayName = view.name || void 0;
        return m;
    })());
    return react.createElement(memoized, new MemoProps1$1(state, equal));
}

/**
 * Avoid rendering the view unless the model has changed.
 * equal: function to compare the previous and the new states
 * view: function to render the model using the dispatch
 * Partially apply with equal and view to get a cached rendering function:
 * let render = lazyView2With equal view
 * render state dispatch
 */
export function Common_lazyView2With(equal, view) {
    const memoized = view.__memo || (view.__memo = (() => {
        const m = react.memo((props) => view(props.model, props.dispatch), (prev, next) => next.equal(prev.model, next.model));
        m.displayName = view.name || void 0;
        return m;
    })());
    return (state) => ((dispatch) => react.createElement(memoized, new MemoProps2$2(state, dispatch, equal)));
}

/**
 * Avoid rendering the view unless the model has changed.
 * equal: function to compare the previous and the new model (a tuple of two states)
 * view: function to render the model using the dispatch
 * Partially apply with equal and view to get a cached rendering function:
 * let render = lazyView3With equal view
 * render state1 state2 dispatch
 */
export function Common_lazyView3With(equal, view) {
    const memoized = view.__memo || (view.__memo = (() => {
        const m = react.memo((props) => {
            const patternInput = props.model;
            return view(patternInput[0], patternInput[1], props.dispatch);
        }, (prev, next) => next.equal(prev.model, next.model));
        m.displayName = view.name || void 0;
        return m;
    })());
    return (state1) => ((state2) => ((dispatch) => react.createElement(memoized, new MemoProps2$2([state1, state2], dispatch, equal))));
}

/**
 * Avoid rendering the view unless the model has changed.
 * view: function of model to render the view
 */
export function Common_lazyView(view) {
    return (state) => Common_lazyViewWith(equals, view, state);
}

/**
 * Avoid rendering the view unless the model has changed.
 * view: function of two arguments to render the model using the dispatch
 */
export function Common_lazyView2(view) {
    return Common_lazyView2With(equals, view);
}

/**
 * Avoid rendering the view unless the model has changed.
 * view: function of three arguments to render the model using the dispatch
 */
export function Common_lazyView3(view) {
    return Common_lazyView3With(equalArrays, view);
}

/**
 * Set the React key on an element for list reconciliation.
 * Useful with lazyView to differentiate sibling memo components:
 * lazyView2 view model dispatch |> withKey "my-id"
 */
export function Common_withKey(key, element) {
    return ({...element, key: key});
}

